import { jwtDecode } from "jwt-decode";
import apiClient from "./ApiInterceptor";

/**
 * Gets all the features for a specific user with corresponding roles an exceptions in a given branch
 * @returns map of features and status (enabled or disabled)
 * @example { "feature1": 1, "feature2": 0, ... }
 */
export const getFeaturesForUser = async () => {
    try {
        const branchId = localStorage.getItem('branch_id');
        const access_token = localStorage.getItem('access_token');
        const decodedToken = jwtDecode(access_token);
        const loggedUserId = decodedToken.sub;
        const response = await apiClient.get(`/features/branch/${branchId}/user/${loggedUserId}`);
        if(response.status === 200){
            return response.data;
        }
        return {};
    } catch (err) {
        console.error('Error fetching feature:', err);
        return {};
    }
}

/**
 * Checks if a feature is globaly enabled.
 * Then, cheks if the user is the same of the owner of the information
 * @param {*} feature that wants to access
 * @param {*} userId owner of the information
 * @returns boolean true if has permissions, false otherwise
 */
export const checkAutoPermissions = async (feature, userId = null) => {
    try {
        const isEnabled = await isFeatureEnabledForBranch(feature);
        if(!isEnabled) {
            return false;
        }
        const access_token = localStorage.getItem('access_token');
        const decodedToken = jwtDecode(access_token);
        const loggedUserId = decodedToken.sub;
        if(userId && String(loggedUserId) === String(userId)){
            return true;
        }
        return false;
    } catch (err) {
        console.error('Error checkAutoPermissions:', err);
        return false;
    }
}

export const isFeatureEnabledForBranch = async (feature) => {
    try {
        const branchId = localStorage.getItem('branch_id');
        const response = await apiClient.get(`/features/${feature}/branch/${branchId}`);
        if(response.status === 200){
            return response.data.isEnabled;
        }
        return false;
    } catch (err) {
        console.error('Error fetching feature:', err);
        return false;
    }
}
